import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  EcommerceWebProcessKickoff,
  EcommerceWebProcessFrontend,
  EcommerceWebProcessQuality,
  EcommerceWebProcessLaunch,
} from "../../../app-constants";

import {
  UnrealGameGDD,
  UnrealGamePrototyping,
  UnrealGameAssetsCreation,
  UnrealGamePostSupport,
} from "../../../app-constants-updated";
import BgImg from "../../images/services-usa/unreal-game-update/unreal_workflow.webp";
import { Link } from "gatsby";

function Ecommercewebprocess() {
  return (
    <section
      className="ecommerce_web_process text_white p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>
              Our Unreal Engine <span>Game Development</span> Workflow
            </h2>
            <p>
              Our Unreal Game Development Company follows a fine-tuned workflow
              to build games that are not only visually stunning but also
              reliable and scalable. From concept to post-launch, we deliver
              industry-leading results with technical precision and ongoing
              support.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  01
                  <h5>Discovery & Planning</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessKickoff}
                </div>
              </div>
              <p>Define requirements and set development roadmap.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  02
                  <h5>GDD Creation</h5>
                </div>
                <div className="ecom_box_icon">{UnrealGameGDD}</div>
              </div>
              <p>Outline gameplay, visuals, and technical specs in detail.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  03
                  <h5>Prototyping</h5>
                </div>
                <div className="ecom_box_icon">{UnrealGamePrototyping}</div>
              </div>
              <p>Build interactive prototypes to test core mechanics.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  04
                  <h5>Asset Creation</h5>
                </div>
                <div className="ecom_box_icon">{UnrealGameAssetsCreation}</div>
              </div>
              <p>Design and integrate high-quality 2D/3D assets.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  05
                  <h5>Core Development</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessFrontend}
                </div>
              </div>
              <p>Code mechanics, physics, and AI for optimal performance.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-xl-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  06
                  <h5>Testing & QA</h5>
                </div>
                <div className="ecom_box_icon">
                  {EcommerceWebProcessQuality}
                </div>
              </div>
              <p>
                Perform extensive testing for functionality and compatibility.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-md-0 mb-4">
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  07
                  <h5>Launch & Deployment</h5>
                </div>
                <div className="ecom_box_icon">{EcommerceWebProcessLaunch}</div>
              </div>
              <p>Finalize and deploy the game, optimizing for all platforms.</p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="ecomm_process_box">
              <div className="ecomm_box_flex">
                <div className="ecomm_num">
                  08
                  <h5>Post-Launch Support</h5>
                </div>
                <div className="ecom_box_icon">{UnrealGamePostSupport}</div>
              </div>
              <p>Provide updates, monitor performance, and fix bugs.</p>
            </div>
          </Col>
        </Row>
        <Row className="justify-content-center text-center">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-3 mt-md-5"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Talk to Our Experts
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ecommercewebprocess;
